import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';
import { LoginPostBindingModel } from '../shared/model/login-post-binding';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private userSubject: BehaviorSubject<any>;
  public user: Observable<any>;

  constructor(
      private router: Router,
      private http: HttpClient
  ) {
      this.userSubject = new BehaviorSubject<any>(null);
      this.user = this.userSubject.asObservable();
  }

  public get userValue(): any {
      return this.userSubject.value;
  }

  login(model: LoginPostBindingModel) {
      return this.http.post<any>(`${environment.baseUrl}authenticate/v1/login`,  {...model, version: "v4"}, { withCredentials: true })
          .pipe(map(user => {
              this.userSubject.next(user.data);
              this.startRefreshTokenTimer();
              return user;
          }));
  }

  logout() {
      this.http.post<any>(`${environment.baseUrl}authenticate/v1/revoke-token`, {version: "v4"}, { withCredentials: true }).subscribe(() => {
        this.userSubject.next(null);
        this.router.navigate(['/']);
      });
      this.stopRefreshTokenTimer();
  }

  refreshToken() {
      return this.http.post<any>(`${environment.baseUrl}authenticate/v1/refresh-token`, {version: "v4"}, { withCredentials: true })
          .pipe(map((user) => {
              this.userSubject.next(user.data);
              this.startRefreshTokenTimer();
              return user;
          }));
  }

  // helper methods

  private refreshTokenTimeout: any;

  private startRefreshTokenTimer() {
      // parse json object from base64 encoded jwt token
      var access_token = null;
      if(this.userValue.access_token){
        access_token = JSON.parse(atob(this.userValue.access_token.split('.')[1]));
      } else if(this.userValue.data){
        access_token = JSON.parse(atob(this.userValue.data.access_token.split('.')[1]));
      }else {
        access_token = JSON.parse(atob(this.userValue.data.access_token.split('.')[1]));
      }

      // set a timeout to refresh the token a minute before it expires
      const expires = new Date(access_token.exp * 1000);
      const timeout = expires.getTime() - Date.now() - (60 * 1000);
      this.refreshTokenTimeout = setTimeout(() => this.refreshToken().subscribe(), timeout);
  }

  private stopRefreshTokenTimer() {
      clearTimeout(this.refreshTokenTimeout);
  }

  getToken(model: LoginPostBindingModel): Observable<LoginPostBindingModel> {
    return this.http.post<LoginPostBindingModel>(environment.baseUrl + 'authenticate/v1/login', {...model, version: "v1"});
  }

  register(user_id:any,password:any) {
    return this.http.post<any>(`${environment.baseUrl}user/v1/register`, {user_id, password}, { withCredentials: true });
}

  //#endregion
}
